import React from 'react'
import styled from 'styled-components'

type Props = {
  children: React.ReactNode
}
export const Board = (props: Props) => {
  return (
    <Root>
      <Main>{props.children}</Main>
    </Root>
  )
}

const Root = styled.div`
  border-radius: 12px;
  border: 1px solid var(--background-3);
  background: var(--background-1);
  overflow: auto;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr auto;
`
const Main = styled.div`
  overflow: auto;
  height: 100%;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`
